import $http from "../axios";

const state = {
  vendingCategories: []
};

const getters = {
  vendingCategories: state => {
    return state.vendingCategories;
  }
};

const actions = {
  getVendingCategories({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`vending-categories`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit(
              "SET_VENDING_CATEGORIES",
              res.data.payload.vendingCategories
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  createVendingCategory(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`create-vending-category`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateVendingCategory(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`update-vending-category`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteVendingCategory(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`delete-vending-category`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_VENDING_CATEGORIES(state, vendingCategories) {
    state.vendingCategories = vendingCategories;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
